<template>
  <div
    class="
      sf-level sf-level-center sf-font-s sf-c-text-light
      rs-sf-progress-legend
    "
  >
    <div v-for="section in modifiedSections" :key="section.key">
      <i :class="section.class" />
      <span>{{ section.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sections: {
      type: Array,
      required: true,
      default: function () {
        return []
      },
    },
  },

  computed: {
    modifiedSections: function () {
      return this.sections.map((section) => ({
        key: section.i18nKey,
        class: {
          'fa fa-square': true,
          'sf-pad-r-1': true,
          [`sf-c-${section.color}`]: true,
        },
        label: this.legendLabel(section),
      }))
    },
  },

  methods: {
    legendLabel(section) {
      return this.I18n.t(section.i18nKey, {
        completed: section.done,
        total: section.total,
      })
    },
  },
}
</script>
